import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterCollection extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    return orderProducts.sort((a, b) => {
      const itemA = a.collection;
      const itemB = b.collection;
      if (itemA && itemB) {
        if (itemA.name > itemB.name) {
          return 1;
        }
        if (itemA.name < itemB.name) {
          return -1;
        }
      }
      return 0;
    });
  }
}

export default OrderProductsSorterCollection;
